import { StorageLocation } from "../../../backend/src/types";
import { ENDPOINT } from "../endpoint/endpoint";
import { errorMessage } from "../function/errorMessage";

type Res<T> = { data: T; error?: any };

export async function getStorageLocations(
  lab_id: number
): Promise<StorageLocation[]> {
  try {
    const res = await fetch(ENDPOINT.storage.getStorageLocations, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lab_id }),
    });
    const { data, error }: Res<StorageLocation[]> = await res.json();
    if (!res.ok) throw new Error(error ?? "Server Error");
    return data ?? [];
  } catch (error) {
    errorMessage("保管場所の取得に失敗しました", error);
    return [];
  }
}

export async function addStorageLocation(
  lab_id: number,
  name: string
): Promise<StorageLocation | null> {
  const res = await fetch(ENDPOINT.storage.addStorageLocation, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ lab_id, name }),
  });
  if (res.status === 409) {
    throw new Error("同じ名称の保管場所が既に存在します。");
  }
  const { data, error }: Res<StorageLocation> = await res.json();
  if (!res.ok) throw new Error(error ?? "Server Error");
  return data;
}

export async function editStorageLocation(
  id: number,
  name: string
): Promise<StorageLocation | null> {
  const res = await fetch(ENDPOINT.storage.editStorageLocation, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, name }),
  });
  if (res.status === 409) {
    throw new Error("同じ名称の保管場所が既に存在します。");
  }
  const { data, error }: Res<StorageLocation> = await res.json();
  if (!res.ok) throw new Error(error ?? "Server Error");
  return data;
}

export async function setStorageKeyManaged(
  id: number,
  key_managed: boolean
): Promise<StorageLocation | null> {
  const res = await fetch(ENDPOINT.storage.setStorageKeyManaged, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, key_managed }),
  });
  const { data, error }: Res<StorageLocation> = await res.json();
  if (!res.ok) throw new Error(error ?? "Server Error");
  return data;
}

export async function deleteStorageLocation(id: number): Promise<void> {
  const res = await fetch(ENDPOINT.storage.deleteStorageLocation, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
  if (!res.ok && res.status !== 204) {
    throw new Error("保管場所の削除に失敗しました");
  }
}
